/**
 * DataNode est de la forme:
   export interface DataNode extends INodeBase<DataNode> {
     id: number;
     data: {  };
     children: DataNode[];
   }
 *
 */

export class INodeItem<DataNode> {
  id: number;
  data: any;  // Copie de DataNode.data
}

export class INodeBase<DataNode> {
  id?: number;
  data?: any;  // Copie de DataNode.data
  children?: INodeBase<DataNode>[];
}

export class INode<DataNode> extends INodeBase<DataNode>{
  item?: INodeItem<DataNode>;
  level?: number;
  expandable?: boolean;
  is_default?: boolean;
  children?: INode<DataNode>[];
}

export class IFlatNode<DataNode> {
  item: INodeItem<DataNode>;
  level: number;
  expandable: boolean;
}

export class INodeMove {
  dragNodeId: number;
  targetNodeId: number;
  pos: 'left' | 'right' | 'last-child';
}

export class IFlatNodeWParent<DataNode> {
  node: IFlatNode<DataNode>;
  parent: IFlatNode<DataNode> | null;
}
